import styled from "styled-components";
import { MainInner } from "@/styles/global";
import { FondCardPadding } from "@/styles/typography";

const LargestHoldingsWrapper = styled(MainInner)`
    ${FondCardPadding}
`;

const LargestHoldingsIconInfo = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
    margin-bottom: 15px;

    svg {
        width: 16px;
        height: 16px;
        margin-right: 3px;
        margin-left: 10px;
    }

    .shareChangeText {
        font-size: 14px;
        color: ${({ theme }) => theme.colors.breadText};
        font-family: "Open Sans", sans-serif;
    }
`;

const S = {
  LargestHoldingsWrapper,
  LargestHoldingsIconInfo,
};

export default S;
